/* ============
 * Vue Router
 * ============
 *
 * The official Router for Vue.js. It deeply integrates with Vue.js core
 * to make building Single Page Applications with Vue.js a breeze.
 *
 * http://router.vuejs.org/en/index.html
 */

import Vue from 'vue';
import VueRouter from 'vue-router';
import Meta from 'vue-meta';
import { createSandbox } from 'vue-kindergarten';
import routes from '@/routes';
import store from '@/store';
import { perimeters } from '@/kindergarten/perimeters';
import RouteGoverness from '@/kindergarten/governesses/RouteGoverness';
import child from '@/kindergarten/child';

Vue.use(VueRouter);
Vue.use(Meta);

export const router = new VueRouter({
  mode: 'history',
  routes,
});
router.beforeEach((to, from, next) => {
  router.app.$Progress.start();
  store.dispatch('auth/check'); // not sure if it is the right way to prevent redirect if session is over TODO: refresh token on each request


  to.matched.some((routeRecord) => {
    const perimeter = perimeters[routeRecord.meta.perimeter];
    const Governess = routeRecord.meta.governess || RouteGoverness;
    const action = routeRecord.meta.perimeterAction || 'route';
    if (perimeter) {
      const sandbox = createSandbox(child(store), {
        governess: new Governess(routeRecord.meta.perimeter),

        perimeters: [
          perimeter,
        ],
      });

      return sandbox.guard(action, { to, from, next });
    }

    return next();
  });
});

router.afterEach(() => {
  //  finish the progress bar
  router.app.$Progress.finish();
});

Vue.router = router;

export default {
  router,
};



// WEBPACK FOOTER //
// ./src/plugins/vue-router.js